import ShopAnchor from './ShopAnchor';
import OverflowingImage from './OverflowingImage';

export { OverflowingImage, ShopAnchor };
